/**
 * The strategy report's cover (#6671, #6684): what the client's viewer and
 * the PDF export both lift off the markdown before rendering it.
 *
 * The report opens with its H1, then (runs since #6671) a lone italic date
 * line, or (earlier runs) an italic byline "Google Ads Strategy · GlitchAds
 * AI · date" and a "Prepared for / Source inputs / ..." blockquote, either
 * of which the model may place after an opening paragraph. Everything
 * before the first H2 is the cover. The band shows the title and the date;
 * the byline and that cover block are the agency's and are not rendered.
 */
export function splitCover(content: string): { body: string; title: string; dateLabel: string | null } {
  const lines = content.split('\n');
  const h1 = lines.findIndex((l) => /^# /.test(l));
  if (h1 === -1) return { body: content, title: 'Strategic Plan', dateLabel: null };
  const title = lines[h1].replace(/^# /, '').trim() || 'Strategic Plan';
  let end = lines.findIndex((l, idx) => idx > h1 && /^## /.test(l));
  if (end === -1) end = lines.length;
  let dateLabel: string | null = null;
  const keep: string[] = [];
  let inCover = false;
  for (let i = h1 + 1; i < end; i++) {
    const line = lines[i];
    if (inCover) {
      if (/^>/.test(line)) continue;
      inCover = false;
    }
    const byline: RegExpMatchArray | null = dateLabel === null ? line.match(/^_(.+)_\s*$/) : null;
    if (byline) {
      const parts: string[] = byline[1].split('·').map((p: string) => p.trim());
      dateLabel = parts[parts.length - 1] || null;
      continue;
    }
    if (/^>\s*\*\*Prepared for:\*\*/.test(line)) {
      inCover = true;
      continue;
    }
    keep.push(line);
  }
  return { body: [...lines.slice(0, h1 + 1), ...keep, ...lines.slice(end)].join('\n'), title, dateLabel };
}
